export default {
    'splash-start-now': 'Start Now',

    'setup-dialog-title': 'Let\'s set up your sales environment',
    'setup-dialog-subtitle': 'We\'ll guide you through simple steps to set up your company and team — we\'ll be ready to go!',

    'setup-step-company-title': 'Set up your company data',
    'setup-step-company-desc': 'Add your company logo and basic information to customize the system to match your identity',

    'setup-step-business-title': 'Define your business type',
    'setup-step-business-desc': 'Choose the field you operate in so we can tailor the system experience to your operations',

    'setup-step-customers-title': 'Define your target customers',
    'setup-step-customers-desc': 'Choose the types of entities you sell to, such as pharmacists, stores, pharmacies, or others',

    'setup-step-team-title': 'Build your sales team structure',
    'setup-step-team-desc': 'Build your organizational chart and define positions to simplify management and follow-up',

    'setup-step-products-title': 'Add products and opening stock',
    'setup-step-products-desc': 'Define your items and set the available quantities to start managing inventory accurately',

    'setup-step-regions-title': 'Define work regions',
    'setup-step-regions-desc': 'Specify the cities and regions covered by your team to organize sales and distribution',

    'setup-step-employees-title': 'Add your employees',
    'setup-step-employees-desc': 'Add your employees to start working immediately',

    'upload-drag-hint': 'Drag the image here or click to select an image from your device',
    'upload-format-note': 'JPG or PNG format, maximum 2 MB',
    'upload-change': 'Change image',
    'upload-remove': 'Remove image',

    'system-setup-title': 'System Setup',
    'optional': '(optional)',

    'field-company-latin': 'Company Name (Latin)',
    'field-program-name': 'Program Name',
    'field-country': 'Country',
    'field-city': 'City',
    'field-english-date': 'English Date',
    'field-phone': 'Phone Number',
    'field-primary-color': 'System Primary Color',
    'field-secondary-color': 'System Secondary Color',
    'stepper-company-info': 'Company Information',
    'stepper-service-areas': 'Service Areas',
    'stepper-org-structure': 'Organizational Structure',
    'stepper-customer-types': 'Customer Types',
    'stepper-business-activity': 'Business Activity',
    'stepper-other-data': 'Other Data Setup',
    'service-area-wholesale-title': 'Wholesale',
    'service-area-wholesale-desc': 'Sell products in large quantities directly to other businesses',
    'service-area-consumer-title': 'Consumer Goods',
    'service-area-consumer-desc': 'Products used daily and purchased repeatedly by consumers on a regular basis',
    'service-area-medical-title': 'Medicine & Healthcare',
    'service-area-medical-desc': 'Medical supplies, medicines, and healthcare essentials',
    'service-area-food-title': 'Food & Beverages',
    'service-area-food-desc': 'Packaged food brands, beverages, sweets, and food products',
    'service-area-other-title': 'Other',
    'service-area-other-desc': 'Specify your other business activities if they do not fit the listed categories',
    'customer-types-title': 'Choose Your Customer Types',
    'customer-type-pharmacies': 'Pharmacies',
    'customer-type-medical-centers': 'Medical Centers',
    'customer-type-wholesalers': 'Wholesalers',
    'customer-type-retail-stores': 'Retail Stores',
    'customer-types-add-title': 'Add Other Store Types',
    'customer-types-add-placeholder': 'Type a new store type',
    'customer-types-add-btn': 'Add',
    'customer-types-empty-title': 'You have not selected any customer type',
    'customer-types-empty-desc': 'You can customize customer types now or add them later from the system settings to match your business.',
    'btn-previous': 'Previous',
    'step-placeholder': 'This step will be customized in the next phase.',
    'btn-next': 'Next',
}
